import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/svg/moves_offer_logo.svg";
import FooterLinkSection from "./FooterLinkSection";
import SocialLinks from "./SocialLinks";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-16 overflow-hidden">
      <div className="container py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10 text-sm">
        <FooterLinkSection
          title="Company"
          links={[
            { to: "/about", label: "About Us" },
            { to: "/support/ticket", label: "Contact Us" },
            { to: "/tips", label: "Tips" },
          ]}
        />

        <FooterLinkSection
          title="Clients"
          links={[{ to: "/faq", label: "FAQ" }]}
        />

        <FooterLinkSection
          title="Policies"
          links={[
            { to: "/accessibility", label: "Accessibility" },
            { to: "/privacy", label: "Privacy Policy" },
            { to: "/cookies", label: "Cookie Policy" },
            { to: "/terms", label: "Terms of Service" },
          ]}
        />

        <FooterLinkSection
          title="MovesOffer Sites"
          links={[{ to: "/calculator", label: "Moving Calculator" }]}
        />
      </div>

      {/* Middle row: logo + socials */}
      <div className="container pb-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 group flex-shrink min-w-0">
          <div className="relative flex-shrink-0">
            <div className="absolute inset-0 bg-primary/10 rounded-full blur-sm group-hover:blur-md transition-all"></div>
            <img
              src={logo}
              alt="Moves Offer"
              className="h-12 w-12 sm:h-14 sm:w-14 relative z-10 rounded-full shadow-lg transform group-hover:scale-105 transition-transform duration-200"
            />
          </div>
          <span className="font-bold text-gray-800 group-hover:text-primary transition-colors whitespace-nowrap">
            Moves Offer
          </span>
        </Link>

        <SocialLinks />
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200 overflow-hidden">
        <div className="container py-6 text-center sm:text-left text-xs text-gray-500">
          <div className="sm:flex sm:items-center sm:justify-between gap-2 sm:gap-4">
            <p className="whitespace-nowrap overflow-hidden text-ellipsis">MovesOffer, Inc. &nbsp;|&nbsp; Calgary, AB, Canada</p>
            <p className="mt-2 sm:mt-0 whitespace-nowrap">
              © {year} MovesOffer — All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
